import { call, put, takeLatest } from "redux-saga/effects";
import { getAllIpRestrictionsApi } from "./ipApi";
import {
  getIpRestrictionsStart,
  getIpRestrictionsSuccess,
  getIpRestrictionsFailure,
} from "./ipSlice";

function* fetchIpRestrictionsSaga(action) {
  try {
    const response = yield call(getAllIpRestrictionsApi, action.payload);
    if (response.success) {
      // response.data usually contains the actual API payload
      yield put(getIpRestrictionsSuccess(response.data));
    } else {
      yield put(getIpRestrictionsFailure(response.error));
    }
  } catch (error) {
    yield put(getIpRestrictionsFailure(error.message));
  }
}

export function* watchIpRestrictions() {
  yield takeLatest(getIpRestrictionsStart.type, fetchIpRestrictionsSaga);
}
